module.exports = __webpack_public_path__ + "static/media/logo-optimized.9b8dcdee.png";